module.exports = __webpack_public_path__ + "img/Teabanner.1f31054a.png";